import 'core-js/client/shim';
import 'reflect-metadata';
import 'core-js/es6';
import 'core-js/es7/reflect';

require('zone.js/dist/zone');


/** WEBPACK FOOTER **
 ** ./app/polyfills.ts
 **/